import { Component } from '@angular/core';

@Component({
	selector: 'panel-body',
	template: '<ng-content></ng-content>',
	styleUrls: ['./panel-body.component.scss'],
	standalone: false
})
export class PanelBodyComponent {}
